/**
 * @generated SignedSource<<34625ffcaf995a4e2e37191f61844e26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postFragment$data = {
  readonly slug: string;
  readonly space: {
    readonly slug: string;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"postAttachmentsPreview_post" | "postBottomActionsFragment" | "postComments_post" | "postContentFragment" | "postCoverFragment" | "postHeaderFragment">;
  readonly " $fragmentType": "postFragment";
};
export type postFragment$key = {
  readonly " $data"?: postFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "club"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "postFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postBottomActionsFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "club",
          "variableName": "club"
        }
      ],
      "kind": "FragmentSpread",
      "name": "postHeaderFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postContentFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postCoverFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postComments_post"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postAttachmentsPreview_post"
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "fa4ee9ddb7712ce22eae8564f80f723c";

export default node;
